package team.platforma.dictionarydata.table

import kotlin.Long
import kotlin.String

public data class AiModel(
  public val id: Long,
  public val name: String,
  public val chapter: Long,
  public val description: String,
  public val cover: String?,
)
